import {ClientContactRole} from '../helpers';

export class ClientContact {
    fullName?: string;
    title?: string;
    company?: string;
    address?: string;
    phone?: string;
    email?: string;
    role?: ClientContactRole;
    clientContactId?: number;
}
